import { render, staticRenderFns } from "./ValidateForm.vue?vue&type=template&id=4c410db8&"
import script from "./ValidateForm.vue?vue&type=script&lang=js&"
export * from "./ValidateForm.vue?vue&type=script&lang=js&"
import style0 from "./ValidateForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports